module.exports = __webpack_public_path__ + "img/super.79c4ba00.png";